<template>
  <div
    class="new-webapp-container"
    v-if="item">
    <v-stepper
      v-model="step"
      vertical>
      <v-stepper-step
        step="1"
        editable>
        {{ $t('serverModel.components.webAppEditionWizard.fillInformation', 'Basic info for your project') }}
      </v-stepper-step>

      <v-stepper-content step="1">
        <we-detail-view
          class="detail"
          display-in="designer_step1"
          :item="item"
          :schema="schema"
          :edit-mode="true" />
        <WebAppAvatarEdition
          v-if="item.device"
          :item="item"
          :device="item.device.id" />

        <div class="stepper-commands">
          <v-spacer />
          <v-btn
            color="success"
            :disabled="!item.label || !item.description"
            @click="step = 2"
            small>
            {{ $t('serverModel.components.webAppEditionWizard.continue', 'Continue') }}
          </v-btn>
        </div>
      </v-stepper-content>

      <v-stepper-step
        step="2"
        :editable="item.label && item.description">
        {{ $t('serverModel.components.webAppEditionWizard.fillCollaboration', 'Info for your Web Application') }}
      </v-stepper-step>

      <v-stepper-content step="2">
        <we-detail-view
          class="detail"
          display-in="designer_step2"
          :item="item"
          :schema="schema"
          :edit-mode="true" />

        <div class="stepper-commands">
          <v-btn
            color="blue darken-1"
            flat
            @click="step--"
            small>
            {{ $t('serverModel.components.webAppEditionWizard.back', 'Back') }}
          </v-btn>
          <v-spacer />
          <v-btn
            color="success"
            :loading="saving"
            :disabled="!canSave"
            @click="save"
            small>
            {{ $t('serverModel.components.webAppEditionWizard.save', 'Save') }}
          </v-btn>
        </div>
      </v-stepper-content>
    </v-stepper>
  </div>
</template>

<script>
import { webAppWizardMixin } from '../mixins/webAppWizard'
import WebAppAvatarEdition from '../components/WebAppAvatarEdition'
import '../assets/webAppWizard.scss'

export default {
  components: { WebAppAvatarEdition },
  mixins: [webAppWizardMixin],
  data () {
    return {
      step: 1
    }
  }
}
</script>
